export function checkIsLoop(step: any): boolean {
  if (!step) return false;
  if (step.uiData) {
    try {
      const uiData = JSON.parse(step.uiData);
      return uiData?.loop || false; // return the value of loop or false if not present
    } catch (e) {
      return false;
    }
  }
  return false;
}

export function checkIsLoopStep(step: any): boolean {
  if (!step) return false;
  if (step?.uiData) {
    try {
      const uiData = JSON.parse(step.uiData);
      return uiData.loopStep || false; // return the value of loopStep or false if not present
    } catch (e) {
      return false;
    }
  }
  return false;
}

export function checkIsLoopEnd(step: any): boolean {
  if (!step) return false;
  if (step.type === "LOOP_END") return true;
  if (step.uiData) {
    try {
      const uiData = JSON.parse(step.uiData);
      return uiData.loopEnd === true;
    } catch {
      return false;
    }
  }
  return false;
}

// For future refs
export function getLoopEndStep(step: any): string | null {
  if (!step || !step.uiData) return null;
  try {
    const uiData = JSON.parse(step.uiData);
    return uiData.loopEndOrigId || null;
  } catch {
    return null;
  }
}
